module.exports = "/_next/static/media/76bea1de2b361ba9a1cad877a0252fdc.svg";